import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { routes } from 'app/routes';
import Cookies from 'universal-cookie';

const withAuth = Component => {
  const AuthenticatedComponent = props => {
    const [isAuthenticated, setIsAuthenticated] = React.useState(false);

    useEffect(() => {
      const cookies = new Cookies();
      const cookie = cookies.get('nic-portal');

      if (cookie) {
        setIsAuthenticated(true);
      }
    }, []);

    if (isAuthenticated) {
      return <Navigate to={routes.HOME} replace />;
    } else {
      return <Component {...props} />;
    }
  };

  return AuthenticatedComponent;
};

export default withAuth;
